"use client"

import type { ReactNode } from "react"

import { ErrorBoundary as HErrorBoundary } from "@highlight-run/next/client"

import { ENVIRONMENT } from "#environment/env"

export function HighlightErrorBoundary({ children }: { children: ReactNode }) {
  if (ENVIRONMENT.NEXT_PUBLIC_NODE_ENV === "development") return children

  return <HErrorBoundary showDialog>{children}</HErrorBoundary>
}
